import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

function useShowUniversalBenchmarks(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.UNIVERSAL_BENCHMARKS_FE, false);
}

export { useShowUniversalBenchmarks };
